import { render, staticRenderFns } from "./WiderrufForm.vue?vue&type=template&id=3d0079f5&scoped=true"
import script from "./WiderrufForm.vue?vue&type=script&lang=ts"
export * from "./WiderrufForm.vue?vue&type=script&lang=ts"
import style0 from "./WiderrufForm.vue?vue&type=style&index=0&id=3d0079f5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0079f5",
  null
  
)

export default component.exports